import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AuthDialogData,
  AuthDialogResponse,
} from '@x/ecommerce-shop/app/core/auth/services/auth.service';

@Component({
  selector: 'x-auth-dialog',
  templateUrl: './auth-dialog.component.html',
  styleUrls: ['./auth-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthDialogComponent {
  defaultData: AuthDialogData = {
    logo: true,
    message: 'Please login to continue',
    heading: 'Login Required',
    canClose: true,
  };

  get data(): AuthDialogData {
    return { ...this.defaultData, ...this.config };
  }

  constructor(
    private dialogRef: MatDialogRef<AuthDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public config: AuthDialogData,
  ) {}

  action(action: AuthDialogResponse) {
    this.dialogRef.close(action);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
